document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('tdp-quick-view-overlay');
  if (!overlay) return;

  const closeBtn = document.getElementById('tdp-qv-close');
  const mainImgEl = document.getElementById('tdp-qv-main-img-el');
  const thumbnailsContainer = document.getElementById('tdp-qv-thumbnails');
  const vendorEl = document.getElementById('tdp-qv-vendor');
  const titleEl = document.getElementById('tdp-qv-title');
  const priceEl = document.getElementById('tdp-qv-price');
  const compareAtEl = document.getElementById('tdp-qv-compare-at');
  const discountEl = document.getElementById('tdp-qv-discount');
  const sizeEl = document.getElementById('tdp-qv-size');
  const optionsContainer = document.getElementById('tdp-qv-options-container');
  const addBtn = document.getElementById('tdp-qv-add-btn');
  const addText = document.getElementById('tdp-qv-add-text');
  const viewFullEl = document.getElementById('tdp-qv-view-full');
  const loadingOverlay = document.getElementById('tdp-qv-loading-overlay');

  let currentProduct = null;
  let currentVariant = null;

  function getSizedImageUrl(src, size) {
    if (!src) return '';
    if (src.includes(`_${size}x`)) return src;
    return src.includes('?') ? `${src}&width=${size}` : `${src}?width=${size}`;
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function openQuickView(handle) {
    overlay.classList.add('is-active');
    
    // Show loading state and clear old data
    if (loadingOverlay) loadingOverlay.classList.add('is-loading');
    mainImgEl.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    thumbnailsContainer.innerHTML = '';
    titleEl.textContent = '';
    vendorEl.textContent = '';
    priceEl.textContent = '';
    compareAtEl.style.display = 'none';
    discountEl.style.display = 'none';
    sizeEl.style.display = 'none';
    optionsContainer.innerHTML = '';
    addBtn.disabled = true;
    addText.textContent = 'Loading...';
    
    // Fetch product JSON
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        currentProduct = product;
        currentVariant = product.variants[0];
        
        vendorEl.textContent = product.vendor;
        titleEl.textContent = product.title;
        viewFullEl.href = `/products/${product.handle}`;
        
        // Render images
        renderImages(product.images, product.title);
        
        // Render variants/options
        renderOptions(product);
        
        // Update Price
        updatePriceAndStock();
        
        // Hide loading state
        if (loadingOverlay) loadingOverlay.classList.remove('is-loading');
      })
      .catch(error => {
        console.error('Quick View Error:', error);
        if (loadingOverlay) loadingOverlay.classList.remove('is-loading');
        addText.textContent = 'Error loading product';
      });
  }

  function renderImages(images, altBase) {
    thumbnailsContainer.innerHTML = '';
    if (!images || images.length === 0) {
      mainImgEl.src = '';
      return;
    }
    
    // Set main image
    mainImgEl.src = getSizedImageUrl(images[0], 800);
    mainImgEl.alt = altBase;

    if (images.length > 1) {
      const maxThumbs = Math.min(images.length, 4);
      for (let i = 0; i < maxThumbs; i++) {
        const btn = document.createElement('button');
        btn.className = `tdp-quick-view-thumbnail ${i === 0 ? 'is-active' : ''}`;
        const img = document.createElement('img');
        
        img.src = getSizedImageUrl(images[i], 200);
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', () => {
          mainImgEl.src = images[i];
          document.querySelectorAll('.tdp-quick-view-thumbnail').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
        });
        thumbnailsContainer.appendChild(btn);
      }
    }
  }

  function renderOptions(product) {
    optionsContainer.innerHTML = '';
    
    // Attempt to extract size from options
    let sizeFound = null;
    
    if (product.variants.length > 1) {
      const title = document.createElement('p');
      title.className = 'tdp-qv-section-title';
      title.textContent = 'Variant';
      optionsContainer.appendChild(title);
      
      const btnContainer = document.createElement('div');
      btnContainer.className = 'tdp-qv-variants';
      
      product.variants.forEach((v, index) => {
        const btn = document.createElement('button');
        btn.className = `tdp-qv-variant-btn ${index === 0 ? 'is-active' : ''}`;
        btn.textContent = v.title;
        if (!v.available) {
          btn.disabled = true;
        }
        btn.addEventListener('click', () => {
          currentVariant = v;
          document.querySelectorAll('.tdp-qv-variant-btn').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          updatePriceAndStock();
          
          if (v.featured_image) {
            mainImgEl.src = getSizedImageUrl(v.featured_image.src, 800);
          }
        });
        btnContainer.appendChild(btn);
        
        // Try to find size if "Size" is an option
        product.options.forEach((opt, idx) => {
           if(opt.name.toLowerCase() === 'size') {
              sizeFound = v[`option${idx+1}`];
           }
        });
      });
      optionsContainer.appendChild(btnContainer);
    }
    
    if (sizeFound) {
      sizeEl.textContent = 'Size: ' + sizeFound;
      sizeEl.style.display = 'block';
    } else {
      sizeEl.style.display = 'none';
    }
  }

  function updatePriceAndStock() {
    if (!currentVariant) return;
    
    priceEl.textContent = formatMoney(currentVariant.price);
    
    if (currentVariant.compare_at_price > currentVariant.price) {
      compareAtEl.textContent = formatMoney(currentVariant.compare_at_price);
      compareAtEl.style.display = 'block';
      const discount = Math.round((1 - (currentVariant.price / currentVariant.compare_at_price)) * 100);
      discountEl.textContent = `${discount}% OFF`;
      discountEl.style.display = 'inline-block';
    } else {
      compareAtEl.style.display = 'none';
      discountEl.style.display = 'none';
    }
    
    if (currentVariant.available) {
      addBtn.disabled = false;
      addText.textContent = `Add to Bag — ${formatMoney(currentVariant.price)}`;
    } else {
      addBtn.disabled = true;
      addText.textContent = "Out of Stock";
    }
  }

  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.tdp-quick-view-btn');
    if (btn) {
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) openQuickView(handle);
    }
  });

  closeBtn.addEventListener('click', () => {
    overlay.classList.remove('is-active');
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.classList.remove('is-active');
    }
  });
  
  addBtn.addEventListener('click', () => {
     if (!currentVariant || !currentVariant.available) return;
     
     addBtn.disabled = true;
     addText.textContent = "Adding...";
     
     let formData = {
      'items': [{
       'id': currentVariant.id,
       'quantity': 1
       }]
     };

     fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => response.json())
     .then(response => {
       overlay.classList.remove('is-active');
       addBtn.disabled = false;
       updatePriceAndStock();
       
       // Reload page to reflect cart change since custom notification handler isn't strictly defined
       window.location.reload();
     })
     .catch((error) => {
       console.error('Error:', error);
       addBtn.disabled = false;
       updatePriceAndStock();
     });
  });
});
